import type { ResponsiveDialogHeaderProps } from '@/shared/components/ui/custom/responsive-dialog';
import { ResponsiveDialogHeader } from '@/shared/components/ui/custom/responsive-dialog';
import { cn } from '@/shared/utils/cn';

export function DownloadModalHeader(props: ResponsiveDialogHeaderProps) {
  const { className, ...rest } = props;
  return (
    <ResponsiveDialogHeader
      className={cn('flex flex-col items-start gap-2', className)}
      {...rest}
    />
  );
}
